"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _strings = require("../Voting/strings");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _FeedbackProvider = require("./FeedbackProvider");

var _propTypes = _interopRequireDefault(require("prop-types"));

function MiddleValue(_ref) {
  var answerIds = _ref.answerIds,
      questionId = _ref.questionId,
      _ref$withNullValue = _ref.withNullValue,
      withNullValue = _ref$withNullValue === void 0 ? true : _ref$withNullValue;
  var feedbacks = (0, _FeedbackProvider.useFeedbackContext)();

  if (feedbacks && feedbacks[questionId]) {
    var votes = answerIds.map(function (id) {
      return feedbacks[questionId].hasOwnProperty(id) ? feedbacks[questionId]["".concat(id, "_abs")] : 0;
    });
    var add = withNullValue ? 0 : 1;
    var totalVotes = votes.reduce(function (acc, cur) {
      return acc + cur;
    }, 0);
    var totalValues = votes.reduce(function (acc, cur, index) {
      return cur * (index + add) + acc;
    }, 0);
    var value = totalValues / totalVotes;
    return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body1"
    }, (0, _strings.getString)('MIDDLEVALUE'), ": ", value);
  }

  return null;
}

MiddleValue.propTypes = {
  answerIds: _propTypes["default"].array,
  questionId: _propTypes["default"].string,
  withNullValue: _propTypes["default"].bool
};
var _default = MiddleValue;
exports["default"] = _default;